import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";

interface Step4ConfigurationPropsFlutter {
  rootWidgetType: string;
  onUpdateState: (field: "rootWidgetType", value: string) => void;
}

const Step4ConfigurationFlutter: React.FC<Step4ConfigurationPropsFlutter> = ({
  rootWidgetType,
  onUpdateState,
}) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">How will you add the SDK?</h2>
          <div className="side-by-side-buttons">
            <PulseSelectButton
              options={[
                { label: "Stateful Root Widget", value: "stateful" },
                { label: "Stateless Root Widget", value: "stateless" },
              ]}
              value={rootWidgetType}
              onChange={(value) => onUpdateState("rootWidgetType", value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step4ConfigurationFlutter;
